"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _qs = _interopRequireDefault(require("qs"));

var _axios = _interopRequireDefault(require("axios"));

var _Header = _interopRequireDefault(require("./Header"));

var _Loader = _interopRequireDefault(require("../ui-components/Loader"));

var _OverviewFilters = _interopRequireDefault(require("./filters/OverviewFilters"));

var _OverviewColumns = _interopRequireWildcard(require("./columns/OverviewColumns"));

var _Table = _interopRequireDefault(require("@insided/deprecated-preact-components/table/Table"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _copyToClipboard = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/copyToClipboard"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var _CustomViewActions = _interopRequireDefault(require("./custom-views/CustomViewActions"));

var _objectKeys = _interopRequireDefault(require("@insided/shared/utils/objectKeys"));

var _EmptyView = _interopRequireDefault(require("@insided/deprecated-control/overview/EmptyView"));

var _utils = require("./utils");

var _globals = require("@insided/shared/utils/globals");

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _isArrayOfStrings = require("@insided/control/utils/isArrayOfStrings");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Overview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Overview, _Component);

  var _super = _createSuper(Overview);

  function Overview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Overview);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "STORAGE_KEY", "".concat(_this.props.type, "-filter-criteria"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "overviewPath", "".concat(_this.props.withCustomViews === 'default' ? '' : "/".concat(_this.props.withCustomViews), "/overview"));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _objectSpread(_objectSpread({
      data: [],
      total: undefined,
      loading: true,
      areFiltersApplied: false,
      onlySearchFilterApplied: false
    }, _this.getDefaultFilteringOptions()), {}, {
      customViewTitle: '',
      customViewError: '',
      showAlert: false,
      alertMessage: '',
      alertType: null,
      alertVisibleFor: null,
      columns: (0, _OverviewColumns.copyColumns)(_this.props.model),
      selectedRows: []
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageChange", function (page) {
      var _this$state$paginatio, _this$props$withPagin, _this$state$paginatio2;

      var onPaginationAction = _this.props.onPaginationAction;
      var pageSize = (_this$state$paginatio = _this.state.pagination) === null || _this$state$paginatio === void 0 ? void 0 : _this$state$paginatio.pageSize;
      var pageSizes = (_this$props$withPagin = _this.props.withPagination) === null || _this$props$withPagin === void 0 ? void 0 : _this$props$withPagin.pageSizes;

      if (onPaginationAction && (_this$state$paginatio2 = _this.state.pagination) !== null && _this$state$paginatio2 !== void 0 && _this$state$paginatio2.pageSize) {
        var _this$state$paginatio3;

        onPaginationAction({
          page: page,
          pageSize: (_this$state$paginatio3 = _this.state.pagination) === null || _this$state$paginatio3 === void 0 ? void 0 : _this$state$paginatio3.pageSize,
          callback: function callback() {
            _this.setState(_objectSpread({}, _this.getDefaultFilteringOptions()));

            _this.updateFilterCriteria('pagination', {
              page: page,
              pageSize: pageSize,
              pageSizes: pageSizes
            });
          }
        });
      } else {
        _this.updateFilterCriteria('pagination', {
          page: page,
          pageSize: pageSize,
          pageSizes: pageSizes
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageSizeChange", function (pageSize) {
      var _this$props$withPagin2, _this$props$withPagin3, _this$props$withPagin4;

      var onPaginationAction = _this.props.onPaginationAction;
      var page = (_this$props$withPagin2 = _this.props.withPagination) === null || _this$props$withPagin2 === void 0 ? void 0 : _this$props$withPagin2.page;
      var pageSizes = (_this$props$withPagin3 = _this.props.withPagination) === null || _this$props$withPagin3 === void 0 ? void 0 : _this$props$withPagin3.pageSizes;

      if (onPaginationAction && (_this$props$withPagin4 = _this.props.withPagination) !== null && _this$props$withPagin4 !== void 0 && _this$props$withPagin4.page) {
        var _this$props$withPagin5;

        onPaginationAction({
          page: (_this$props$withPagin5 = _this.props.withPagination) === null || _this$props$withPagin5 === void 0 ? void 0 : _this$props$withPagin5.page,
          pageSize: pageSize,
          callback: function callback() {
            _this.setState(_objectSpread({}, _this.getDefaultFilteringOptions()));

            _this.updateFilterCriteria('pagination', {
              page: page,
              pageSize: pageSize,
              pageSizes: pageSizes
            });
          }
        });
      } else {
        _this.updateFilterCriteria('pagination', {
          page: page,
          pageSize: pageSize,
          pageSizes: pageSizes
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSortChange", function (order) {
      var _this$state$sort;

      var sort = _this.state.sort;
      var currentOrder = sort && Object.keys(sort).filter(function (currentOrder) {
        return currentOrder === order;
      });

      if (currentOrder && currentOrder.length === 0) {
        _this.setState({
          sort: (0, _defineProperty2.default)({}, order, 'asc')
        });
      }

      var direction = (_this$state$sort = _this.state.sort) === null || _this$state$sort === void 0 ? void 0 : _this$state$sort[order];
      if (direction === 'desc') _this.updateFilterCriteria('sort', (0, _defineProperty2.default)({}, order, 'asc'));
      if (direction === 'asc') _this.updateFilterCriteria('sort', (0, _defineProperty2.default)({}, order, 'desc'));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFilterChange", function (filter, payload) {
      var _this$props$withPagin6, _this$state$paginatio4, _this$state$paginatio5;

      var _this$state$filters = _this.state.filters,
          filters = _this$state$filters === void 0 ? {} : _this$state$filters;
      var appliedFilters = Object.fromEntries(Object.entries(_objectSpread(_objectSpread({}, filters), {}, (0, _defineProperty2.default)({}, filter, payload))).filter(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            _ = _ref2[0],
            value = _ref2[1];

        return value !== null;
      }));
      var pageSizes = (_this$props$withPagin6 = _this.props.withPagination) === null || _this$props$withPagin6 === void 0 ? void 0 : _this$props$withPagin6.pageSizes;
      var pagination = {
        page: 1,
        pageSize: (_this$state$paginatio4 = (_this$state$paginatio5 = _this.state.pagination) === null || _this$state$paginatio5 === void 0 ? void 0 : _this$state$paginatio5.pageSize) !== null && _this$state$paginatio4 !== void 0 ? _this$state$paginatio4 : 25,
        pageSizes: pageSizes
      };
      var areFiltersApplied = JSON.stringify(appliedFilters) !== JSON.stringify(_this.getDefaultFilteringOptions().filters);
      var onlySearchFilterApplied = areFiltersApplied && Object.keys(appliedFilters).length === 1 && !!appliedFilters.search;

      _this.updateFilterCriteriaBatch({
        filters: appliedFilters,
        pagination: pagination,
        areFiltersApplied: areFiltersApplied,
        onlySearchFilterApplied: onlySearchFilterApplied
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClearFilterCriteria", function () {
      if (Overview.isCustomView() || Overview.isSharedView()) {
        _this.setState(_objectSpread(_objectSpread({}, _this.getDefaultFilteringOptions()), {}, {
          areFiltersApplied: false,
          onlySearchFilterApplied: false
        }), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.fetch();

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      } else {
        _this.setState(_objectSpread(_objectSpread({}, _this.getDefaultFilteringOptions()), {}, {
          areFiltersApplied: false,
          onlySearchFilterApplied: false
        }), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this.fetch().then(function () {
                    window.sessionStorage.setItem(_this.STORAGE_KEY, JSON.stringify(_this.getDefaultFilteringOptions()));
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleShareView", function () {
      var sharableViewUrl = _this.getSharableViewUrl();

      (0, _copyToClipboard.default)(sharableViewUrl);

      _this.setState({
        showAlert: true,
        alertMessage: 'Link copied to clipboard!',
        alertType: 'success',
        alertVisibleFor: 3000
      });

      _this.trackCustomViewShared();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDeleteCustomView", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var customViewId;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              customViewId = _this.state.customViewId;
              _context3.next = 3;
              return _axios.default.delete("/view/".concat(customViewId), {
                data: {
                  csrfToken: (0, _csrfToken.csrfToken)()
                }
              }).then(function () {
                return window.location.assign(_this.overviewPath);
              }).catch(function () {
                _this.showSomethingWentWrong();
              });

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSaveCustomView", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(newCustomViewName) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(newCustomViewName !== undefined)) {
                  _context4.next = 11;
                  break;
                }

                if (!(newCustomViewName === '')) {
                  _context4.next = 4;
                  break;
                }

                _this.setState({
                  customViewError: 'Please enter a name for your custom view'
                });

                return _context4.abrupt("return");

              case 4:
                if (!(newCustomViewName.length > 250)) {
                  _context4.next = 7;
                  break;
                }

                _this.setState({
                  customViewError: 'Maximum length: 250 characters. Please reduce the length of the name of your custom view'
                });

                return _context4.abrupt("return");

              case 7:
                _context4.next = 9;
                return _this.createCustomView(newCustomViewName);

              case 9:
                _context4.next = 16;
                break;

              case 11:
                _this.validateCustomViewTitleName();

                if (!(_this.state.alertType === 'error')) {
                  _context4.next = 14;
                  break;
                }

                return _context4.abrupt("return");

              case 14:
                _context4.next = 16;
                return _this.updateCustomView();

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCustomViewCreateSuccess", function (response) {
      var data = response.data;

      if (data === undefined) {
        return;
      }

      _this.redirectToCustomView(data.viewId);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCustomViewUpdateSuccess", function () {
      _this.redirectToCustomView(_this.state.customViewId);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCustomViewCreateError", function (error) {
      if (error.response && error.response.status === 422 && error.response.data) {
        var errors = error.response.data.errors;
        var errorMessage = '';

        for (var err in errors) {
          errorMessage += "".concat(errors[err], ". ");
        }

        _this.setState({
          customViewError: errorMessage
        });

        return;
      }

      _this.showSomethingWentWrong();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "performBulkAction", /*#__PURE__*/function () {
      var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(_ref7) {
        var onClick, successMessage, errorMessages, _this$state, data, selectedRows, pagination, selectedObjects, isData, page;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                onClick = _ref7.onClick, successMessage = _ref7.successMessage, errorMessages = _ref7.errorMessages;

                _this.setState({
                  loading: true
                });

                _this$state = _this.state, data = _this$state.data, selectedRows = _this$state.selectedRows, pagination = _this$state.pagination;
                selectedObjects = data.filter(function (item) {
                  return (// @ts-expect-error
                    selectedRows.includes(item[_this.props.rowId])
                  );
                });
                isData = data.length - selectedObjects.length >= 0;
                page = (0, _utils.getPageAfterBulkAction)(pagination, isData);

                _this.handleRefresh(page);

                _context6.next = 9;
                return onClick(selectedObjects).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
                  return _regenerator.default.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return _this.fetch();

                        case 2:
                          _this.setState({
                            showAlert: true,
                            alertMessage: successMessage,
                            alertType: 'success',
                            alertVisibleFor: 3000
                          });

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }))).catch(function (e) {
                  return _this.showSomethingWentWrong(e, errorMessages);
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectRow", function (rowId, checked) {
      _this.setState(function (prevState) {
        return {
          selectedRows: checked ? [].concat((0, _toConsumableArray2.default)(prevState.selectedRows), [rowId]) : prevState.selectedRows.filter(function (selectedRowId) {
            return selectedRowId !== rowId;
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectAll", function () {
      _this.setState(function (_ref10) {
        var selectedRows = _ref10.selectedRows,
            data = _ref10.data;
        return {
          selectedRows: selectedRows.length === data.length ? [] : data.map(function (row) {
            return row[_this.props.rowId];
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "applySelectedColumns", function (columns) {
      _this.setState({
        columns: columns
      });

      if (Overview.isCustomView() || Overview.isSharedView()) {
        return;
      }

      var storage = JSON.parse(window.sessionStorage.getItem(_this.STORAGE_KEY));
      storage.columns = _this.getColumnsForView(columns);
      window.sessionStorage.setItem(_this.STORAGE_KEY, JSON.stringify(storage));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStateAwareHeaderComponent", function () {
      var StateAwareHeaderComponent = _this.props.StateAwareHeaderComponent;
      var _this$state2 = _this.state,
          data = _this$state2.data,
          total = _this$state2.total,
          loading = _this$state2.loading,
          areFiltersApplied = _this$state2.areFiltersApplied,
          onlySearchFilterApplied = _this$state2.onlySearchFilterApplied,
          filters = _this$state2.filters,
          pagination = _this$state2.pagination,
          sort = _this$state2.sort;
      return StateAwareHeaderComponent && (0, _preact.h)(StateAwareHeaderComponent, {
        data: data,
        total: total,
        loading: loading,
        areFiltersApplied: areFiltersApplied,
        onlySearchFilterApplied: onlySearchFilterApplied,
        filters: filters,
        pagination: pagination,
        sort: sort
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStateAwareDashboardComponent", function () {
      var StateAwareDashboardComponent = _this.props.StateAwareDashboardComponent;
      var _this$state3 = _this.state,
          data = _this$state3.data,
          total = _this$state3.total,
          loading = _this$state3.loading,
          areFiltersApplied = _this$state3.areFiltersApplied,
          filters = _this$state3.filters;
      return StateAwareDashboardComponent && (0, _preact.h)(StateAwareDashboardComponent, {
        data: data,
        total: total,
        loading: loading,
        areFiltersApplied: areFiltersApplied,
        filters: filters
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTitleChanged", function (title) {
      var onTitleChanged = _this.props.onTitleChanged;
      onTitleChanged ? onTitleChanged(title) : _this.setState({
        customViewTitle: title
      });
    });
    _this.handleResponse = _this.handleResponse.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPageChange = _this.onPageChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPageSizeChange = _this.onPageSizeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFilterChange = _this.handleFilterChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClearFilterCriteria = _this.handleClearFilterCriteria.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleShareView = _this.handleShareView.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSortChange = _this.onSortChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSaveCustomView = _this.handleSaveCustomView.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRefresh = _this.handleRefresh.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCustomViewCreateError = _this.handleCustomViewCreateError.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCustomViewCreateSuccess = _this.handleCustomViewCreateSuccess.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCustomViewUpdateSuccess = _this.handleCustomViewUpdateSuccess.bind((0, _assertThisInitialized2.default)(_this));
    _this.applySelectedColumns = _this.applySelectedColumns.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelectRow = _this.onSelectRow.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelectAll = _this.onSelectAll.bind((0, _assertThisInitialized2.default)(_this));
    _this.performBulkAction = _this.performBulkAction.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDeleteCustomView = _this.handleDeleteCustomView.bind((0, _assertThisInitialized2.default)(_this));
    _this.applyClientSideFilters = _this.applyClientSideFilters.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Overview, [{
    key: "getDefaultFilteringOptions",
    value: function getDefaultFilteringOptions() {
      var _this$props = this.props,
          withFilters = _this$props.withFilters,
          withSearch = _this$props.withSearch,
          withSorting = _this$props.withSorting,
          withPagination = _this$props.withPagination,
          defaultFilteringOptions = _this$props.defaultFilteringOptions;
      var filteringOptions = {};

      if (defaultFilteringOptions) {
        return _objectSpread({}, defaultFilteringOptions);
      }

      if (withFilters) {
        var emptyFilters = {};

        if (withSearch) {
          Object.assign(emptyFilters, {
            search: ''
          });
        }

        Object.assign(filteringOptions, {
          filters: emptyFilters
        });
      }

      if (withSorting) {
        Object.assign(filteringOptions, {
          sort: withSorting
        });
      }

      if (withPagination) {
        var page = withPagination.page,
            pageSize = withPagination.pageSize,
            pageSizes = withPagination.pageSizes;
        Object.assign(filteringOptions, {
          pagination: {
            page: page,
            pageSize: pageSize,
            pageSizes: pageSizes
          }
        });
      }

      return filteringOptions;
    }
  }, {
    key: "applyViewFromStorage",
    value: function applyViewFromStorage() {
      if (!window.sessionStorage.getItem(this.STORAGE_KEY)) {
        window.sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.getDefaultFilteringOptions()));
      } else {
        var _JSON$parse = JSON.parse(window.sessionStorage.getItem(this.STORAGE_KEY)),
            _JSON$parse$filters = _JSON$parse.filters,
            filters = _JSON$parse$filters === void 0 ? {} : _JSON$parse$filters,
            pagination = _JSON$parse.pagination,
            _sort2 = _JSON$parse.sort,
            columns = _JSON$parse.columns;

        var appliedFilters = Object.fromEntries(Object.entries(filters).filter(function (_ref11) {
          var _ref12 = (0, _slicedToArray2.default)(_ref11, 2),
              _ = _ref12[0],
              value = _ref12[1];

          return value !== null;
        }));
        var areFiltersApplied = JSON.stringify(appliedFilters) !== JSON.stringify(this.getDefaultFilteringOptions().filters);
        var onlySearchFilterApplied = areFiltersApplied && Object.keys(appliedFilters).length === 1 && !!appliedFilters.search;
        this.setState({
          filters: appliedFilters,
          pagination: pagination,
          sort: _sort2,
          areFiltersApplied: areFiltersApplied,
          onlySearchFilterApplied: onlySearchFilterApplied
        });
        if (columns) this.setState({
          columns: this.getColumnsFromView(columns)
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(previousProps) {
        var pagination, page;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (this.props.onOverviewRefresh && this.props.needOverviewRefresh && this.props.needOverviewRefresh !== previousProps.needOverviewRefresh) {
                  pagination = this.state.pagination;
                  page = pagination === null || pagination === void 0 ? void 0 : pagination.page;
                  this.handleRefresh(page !== null && page !== void 0 ? page : 1);
                  this.props.onOverviewRefresh();
                }

                if (JSON.stringify(previousProps.additionalFilters) !== JSON.stringify(this.props.additionalFilters)) {
                  if (this.props.additionalFilters) {
                    this.handleFilterChange(Object.keys(this.props.additionalFilters)[0], Object.values(this.props.additionalFilters)[0]);
                  }
                }

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function componentDidUpdate(_x3) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "getView",
    value: function () {
      var _getView = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        var customViewId, sharedView;
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                customViewId = Overview.getCustomViewId();

                if (!customViewId) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 4;
                return this.fetchCustomView(customViewId);

              case 4:
                return _context8.abrupt("return");

              case 5:
                sharedView = Overview.getSharedView();

                if (!sharedView) {
                  _context8.next = 9;
                  break;
                }

                this.setSharedView(sharedView);
                return _context8.abrupt("return");

              case 9:
                this.applyViewFromStorage();

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getView() {
        return _getView.apply(this, arguments);
      }

      return getView;
    }()
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
        var _this2 = this;

        var search;
        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                search = _qs.default.parse(window.location.search, {
                  ignoreQueryPrefix: true
                });

                if (search !== null && search !== void 0 && search.conversion) {
                  this.setState({
                    alertMessage: 'We are converting your article. Please refresh again after a few moments.',
                    alertType: 'success',
                    showAlert: true
                  });
                }

                _context9.next = 4;
                return this.getView();

              case 4:
                _context9.next = 6;
                return this.fetch();

              case 6:
                (0, _globals.subscribe)('show_alert', function (_ref13) {
                  var alertType = _ref13.alertType,
                      message = _ref13.message;

                  _this2.setState({
                    alertMessage: message,
                    alertType: alertType,
                    alertVisibleFor: 3000,
                    showAlert: true
                  });
                });

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchCustomView",
    value: function () {
      var _fetchCustomView = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(viewId) {
        var _this3 = this;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _axios.default.get("/view/".concat(viewId)).then(function (res) {
                  return _this3.setCustomView(res, viewId);
                }).catch(function () {});

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function fetchCustomView(_x4) {
        return _fetchCustomView.apply(this, arguments);
      }

      return fetchCustomView;
    }()
  }, {
    key: "applyClientSideFilters",
    value: function applyClientSideFilters(response) {
      var filters = this.state.filters;
      var clientSideFilter = this.props.clientSideFilter;

      if (response && response.data.length > 0 && clientSideFilter) {
        return clientSideFilter(response.data, filters);
      }

      return response;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
        var filters, dynamicFields;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                this.setState({
                  loading: true,
                  selectedRows: []
                });
                filters = this.state.filters;
                dynamicFields = {};

                if (filters !== null && filters !== void 0 && filters.assignedModerator) {
                  Object.assign(dynamicFields, {
                    assignedModerator: filters === null || filters === void 0 ? void 0 : filters.assignedModerator.map(function (filter) {
                      return filter.value;
                    })
                  });
                }

                if (filters !== null && filters !== void 0 && filters.author) {
                  Object.assign(dynamicFields, {
                    author: filters === null || filters === void 0 ? void 0 : filters.author.map(function (filter) {
                      return filter.value;
                    })
                  });
                }

                if (filters !== null && filters !== void 0 && filters.userTag) {
                  Object.assign(dynamicFields, {
                    userTag: filters === null || filters === void 0 ? void 0 : filters.userTag.map(function (filter) {
                      return filter.value;
                    })
                  });
                }

                if (filters !== null && filters !== void 0 && filters.productArea) {
                  Object.assign(dynamicFields, {
                    productArea: filters === null || filters === void 0 ? void 0 : filters.productArea.map(function (filter) {
                      return filter.id;
                    })
                  });
                }

                if (filters !== null && filters !== void 0 && filters.publicTag) {
                  Object.assign(dynamicFields, {
                    publicTag: filters === null || filters === void 0 ? void 0 : filters.publicTag.map(function (filter) {
                      return filter.name;
                    })
                  });
                }

                if (filters !== null && filters !== void 0 && filters.moderatorTag) {
                  Object.assign(dynamicFields, {
                    moderatorTag: (0, _isArrayOfStrings.isArrayOfStrings)(filters.moderatorTag) ? filters.moderatorTag : filters === null || filters === void 0 ? void 0 : filters.moderatorTag.map(function (filter) {
                      return filter.name;
                    })
                  });
                }

                if (filters !== null && filters !== void 0 && filters.role) {
                  Object.assign(dynamicFields, {
                    role: filters === null || filters === void 0 ? void 0 : filters.role.map(function (filter) {
                      return filter.name;
                    })
                  });
                }

                _context11.next = 12;
                return this.fetchData(dynamicFields, filters);

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function fetch() {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(dynamicFields, filters) {
        var _this$props2, endpoint, dataSource, onPartialSuccess, _this$props2$addition, additionalFilters, _this$state4, pagination, sort, response, _apiResponse$data, apiResponse, isLastPageEmpty;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this$props2 = this.props, endpoint = _this$props2.endpoint, dataSource = _this$props2.dataSource, onPartialSuccess = _this$props2.onPartialSuccess, _this$props2$addition = _this$props2.additionalFilters, additionalFilters = _this$props2$addition === void 0 ? undefined : _this$props2$addition;
                _this$state4 = this.state, pagination = _this$state4.pagination, sort = _this$state4.sort;
                _context12.prev = 2;

                if (!endpoint) {
                  _context12.next = 11;
                  break;
                }

                _context12.next = 6;
                return _axios.default.post(endpoint, {
                  pagination: pagination,
                  sort: sort,
                  filters: _objectSpread(_objectSpread({}, filters), dynamicFields)
                });

              case 6:
                apiResponse = _context12.sent;

                if ((_apiResponse$data = apiResponse.data) !== null && _apiResponse$data !== void 0 && _apiResponse$data.partial && onPartialSuccess) {
                  onPartialSuccess();
                }

                response = {
                  data: this.props.dataKey ? apiResponse.data[this.props.dataKey] : [],
                  total: apiResponse.data.total || undefined
                };
                _context12.next = 15;
                break;

              case 11:
                if (!(dataSource && pagination)) {
                  _context12.next = 15;
                  break;
                }

                _context12.next = 14;
                return dataSource({
                  pagination: pagination,
                  sort: sort,
                  filters: additionalFilters ? _objectSpread(_objectSpread({}, filters), additionalFilters) : filters
                });

              case 14:
                response = _context12.sent;

              case 15:
                if (response) {
                  response = this.applyClientSideFilters(response);
                  this.handleResponse(response);
                }

                isLastPageEmpty = response && pagination && pagination.page > 1 && pagination.page > Math.ceil(response.total / pagination.pageSize);

                if (isLastPageEmpty) {
                  this.onPageChange(pagination.page - 1);
                }

                _context12.next = 24;
                break;

              case 20:
                _context12.prev = 20;
                _context12.t0 = _context12["catch"](2);
                this.setState({
                  loading: false
                }); // Hide error message on reported, pending, trash-can overview when there is no content

                if (!['report', 'pending', 'trash-can'].includes(this.props.type)) this.showSomethingWentWrong();

              case 24:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[2, 20]]);
      }));

      function fetchData(_x5, _x6) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "createCustomView",
    value: function () {
      var _createCustomView = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(name) {
        var _this$state5, filters, sort, columns, data;

        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this$state5 = this.state, filters = _this$state5.filters, sort = _this$state5.sort, columns = _this$state5.columns;
                data = {
                  name: name,
                  criteria: {
                    filters: filters,
                    sort: sort,
                    columns: this.getColumnsForView(columns)
                  },
                  type: this.props.withCustomViews
                };
                _context13.next = 4;
                return _axios.default.put('/view', data).then(this.handleCustomViewCreateSuccess).catch(this.handleCustomViewCreateError);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function createCustomView(_x7) {
        return _createCustomView.apply(this, arguments);
      }

      return createCustomView;
    }()
  }, {
    key: "updateCustomView",
    value: function () {
      var _updateCustomView = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
        var _this4 = this;

        var _this$state6, customViewId, customViewTitle, filters, sort, columns, data;

        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this$state6 = this.state, customViewId = _this$state6.customViewId, customViewTitle = _this$state6.customViewTitle, filters = _this$state6.filters, sort = _this$state6.sort, columns = _this$state6.columns;
                data = {
                  name: customViewTitle,
                  criteria: {
                    filters: filters,
                    sort: sort,
                    columns: this.getColumnsForView(columns)
                  },
                  type: this.props.withCustomViews
                };
                _context14.next = 4;
                return _axios.default.post("/view/".concat(customViewId), data).then(this.handleCustomViewUpdateSuccess).catch(function () {
                  return _this4.showSomethingWentWrong();
                });

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function updateCustomView() {
        return _updateCustomView.apply(this, arguments);
      }

      return updateCustomView;
    }()
  }, {
    key: "handleRefresh",
    value: function handleRefresh(page) {
      this.onPageChange(page);
    }
  }, {
    key: "updateFilterCriteria",
    value: function updateFilterCriteria(key, value) {
      var _this5 = this;

      if (Overview.isCustomView() || Overview.isSharedView()) {
        this.setState((0, _defineProperty2.default)({}, key, value), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
          return _regenerator.default.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 2;
                  return _this5.fetch();

                case 2:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15);
        })));
      } else {
        var storage = JSON.parse(window.sessionStorage.getItem(this.STORAGE_KEY));
        storage[key] = value;
        window.sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(storage));
        this.setState((0, _defineProperty2.default)({}, key, storage[key]), /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16() {
          return _regenerator.default.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  _context16.next = 2;
                  return _this5.fetch();

                case 2:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16);
        })));
      }
    }
  }, {
    key: "updateFilterCriteriaBatch",
    value: function updateFilterCriteriaBatch(updates) {
      var _this6 = this;

      if (Overview.isCustomView() || Overview.isSharedView()) {
        this.setState(updates, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
          return _regenerator.default.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  _context17.next = 2;
                  return _this6.fetch();

                case 2:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17);
        })));
      } else {
        var storage = JSON.parse(window.sessionStorage.getItem(this.STORAGE_KEY));
        Object.keys(updates).forEach(function (key) {
          storage[key] = updates[key];
        });
        window.sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(storage));
        this.setState(updates, /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
          return _regenerator.default.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  _context18.next = 2;
                  return _this6.fetch();

                case 2:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        })));
      }
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      this.setState(_objectSpread({
        loading: false
      }, response));
    }
  }, {
    key: "redirectToCustomView",
    value: function redirectToCustomView(viewId) {
      window.location.assign("".concat(this.overviewPath, "/").concat(viewId, "?showMessage=success"));
    }
  }, {
    key: "showSomethingWentWrong",
    value: function showSomethingWentWrong(e, errorMessages) {
      var _e$response;

      var message = 'Something went wrong. Please try again';

      if (e !== null && e !== void 0 && (_e$response = e.response) !== null && _e$response !== void 0 && _e$response.status && errorMessages) {
        if (e.response.status === 401 && errorMessages['401']) {
          message = errorMessages['401'];
        } else if (e.response.status === 422 && errorMessages['422']) {
          message = errorMessages['422'];
        }
      }

      this.setState({
        showAlert: true,
        alertMessage: message,
        alertType: 'error',
        alertVisibleFor: 3000,
        loading: false
      });
    }
  }, {
    key: "getColumnsFromView",
    value: function getColumnsFromView(viewColumns) {
      return this.state.columns.map(function (column) {
        var viewColumn = viewColumns.find(function (viewColumn) {
          return column.accessor === viewColumn.accessor;
        });
        if (viewColumn) column.isHidden = viewColumn.isHidden;
        return column;
      });
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getColumnsForView",
    value: function getColumnsForView(columns) {
      return columns.map(function (column) {
        return {
          accessor: column.accessor,
          isHidden: !!column.isHidden
        };
      });
    }
  }, {
    key: "setCustomView",
    value: function setCustomView(response, customViewId) {
      if (response.data.length === 0) {
        return;
      }

      var _response$data = response.data,
          name = _response$data.name,
          criteria = _response$data.criteria;
      var filters = criteria.filters,
          sort = criteria.sort,
          columns = criteria.columns;
      this.setState({
        customViewId: customViewId,
        // eslint-disable-next-line react/no-access-state-in-setstate
        filters: _objectSpread(_objectSpread({}, this.state.filters), filters),
        sort: sort,
        areFiltersApplied: true,
        customViewTitle: name
      });
      columns && this.setState({
        columns: this.getColumnsFromView(columns)
      });

      if (window.location.search.includes('?showMessage=success')) {
        this.setState({
          showAlert: true,
          alertMessage: "Custom view \u2018".concat(name, "\u2019 saved successfully!"),
          alertType: 'success',
          alertVisibleFor: 3000
        });
        window.history.replaceState(null, '', customViewId.toString());
        this.trackCustomViewSaved();
      } else {
        this.trackCustomViewOpened();
      }
    }
  }, {
    key: "setSharedView",
    value: function setSharedView(sharedView) {
      var filters = sharedView.filters,
          sort = sharedView.sort,
          columns = sharedView.columns;
      this.setState({
        filters: filters,
        sort: sort
      });
      columns && this.setState({
        columns: this.getColumnsFromView(columns)
      });
    }
  }, {
    key: "getViewParameters",
    value: function getViewParameters() {
      var _this$state7 = this.state,
          filters = _this$state7.filters,
          sort = _this$state7.sort,
          columns = _this$state7.columns;
      return JSON.stringify({
        filters: filters,
        sort: sort,
        columns: this.getColumnsForView(columns)
      });
    }
  }, {
    key: "getSharableViewUrl",
    value: function getSharableViewUrl() {
      return "".concat(window.location.origin).concat(this.overviewPath, "?view=").concat(window.btoa(this.getViewParameters()));
    }
  }, {
    key: "getPaginationProps",
    value: function getPaginationProps() {
      var withPagination = this.props.withPagination;
      if (!withPagination) return;
      var _this$state8 = this.state,
          pagination = _this$state8.pagination,
          total = _this$state8.total;
      return {
        pagination: _objectSpread(_objectSpread({}, pagination), {}, {
          total: total
        }),
        onPageChange: this.onPageChange,
        onPageSizeChange: this.onPageSizeChange
      };
    }
  }, {
    key: "getTableProps",
    value: function getTableProps() {
      var _this7 = this;

      var _this$props3 = this.props,
          withPagination = _this$props3.withPagination,
          withSorting = _this$props3.withSorting,
          withColumns = _this$props3.withColumns,
          model = _this$props3.model,
          rowId = _this$props3.rowId,
          dataKey = _this$props3.dataKey,
          bulkActions = _this$props3.bulkActions,
          entity = _this$props3.entity,
          type = _this$props3.type,
          dataElementName = _this$props3.dataElementName,
          dataTrackType = _this$props3.dataTrackType,
          _this$props3$withMult = _this$props3.withMultiSelect,
          withMultiSelect = _this$props3$withMult === void 0 ? true : _this$props3$withMult,
          _this$props3$withActi = _this$props3.withActionElements,
          withActionElements = _this$props3$withActi === void 0 ? true : _this$props3$withActi,
          _this$props3$withRefr = _this$props3.withRefreshButton,
          withRefreshButton = _this$props3$withRefr === void 0 ? true : _this$props3$withRefr,
          _this$props3$Addition = _this$props3.AdditionalActionElements,
          AdditionalActionElements = _this$props3$Addition === void 0 ? null : _this$props3$Addition,
          _this$props3$classNam = _this$props3.className,
          className = _this$props3$classNam === void 0 ? [] : _this$props3$classNam;
      var _this$state9 = this.state,
          data = _this$state9.data,
          columns = _this$state9.columns,
          selectedRows = _this$state9.selectedRows,
          pagination = _this$state9.pagination;
      var page = pagination === null || pagination === void 0 ? void 0 : pagination.page;
      var tableProps = {
        model: columns,
        rows: data,
        rowId: rowId,
        firstColumnSticky: true,
        actionElements: withActionElements ? (0, _preact.h)("div", {
          className: "overview_table-action-elements"
        }, AdditionalActionElements, withRefreshButton && (0, _preact.h)(_Button.default, {
          className: "refresh-button",
          onClick: function onClick() {
            return _this7.handleRefresh(page !== null && page !== void 0 ? page : 1);
          },
          size: "medium",
          "data-track-type": dataTrackType,
          "data-element-name": dataElementName ? "".concat(dataElementName, " refresh button") : undefined,
          title: (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
            icon: "refresh",
            height: 12,
            width: 12
          }), "Refresh")
        }), withColumns && (0, _preact.h)(_OverviewColumns.default, {
          selectedColumns: columns,
          defaultColumns: model,
          applySelectedColumns: this.applySelectedColumns
        })) : undefined,
        withMultiSelect: withMultiSelect,
        onSelectRow: this.onSelectRow,
        onSelectAll: this.onSelectAll,
        onClearSelection: function onClearSelection() {
          return _this7.setState({
            selectedRows: []
          });
        },
        selectedRows: selectedRows,
        allSelected: selectedRows.length === data.length,
        entity: entity !== null && entity !== void 0 ? entity : dataKey,
        bulkActions: (0, _preact.h)("div", {
          className: "overview-bulk-actions"
        }, bulkActions === null || bulkActions === void 0 ? void 0 : bulkActions.map(function (BulkActionComponent, id) {
          return (0, _preact.h)(BulkActionComponent, {
            key: "bulk-action-".concat(id),
            numberOfSelectedItems: selectedRows.length,
            performBulkAction: _this7.performBulkAction,
            type: type
          });
        })),
        classes: className
      };

      if (withSorting) {
        var _sort3 = this.state.sort;
        _sort3 && Object.keys(_sort3).forEach(function (key) {
          Object.assign(tableProps, {
            sort: {
              order: key,
              direction: _sort3[key]
            },
            onSortChange: _this7.onSortChange
          });
        });
      }

      if (withPagination) {
        Object.assign(tableProps, {
          withPagination: this.getPaginationProps()
        });
      }

      return tableProps;
    }
  }, {
    key: "validateCustomViewTitleName",
    value: function validateCustomViewTitleName() {
      var customViewTitle = this.state.customViewTitle;

      if (!customViewTitle) {
        this.setState({
          showAlert: true,
          alertType: 'error',
          alertMessage: 'Please enter a name for your custom view'
        });
      }
    }
  }, {
    key: "trackCustomViewOpened",
    value: function trackCustomViewOpened() {
      _publish.default.trackEvent('userevent', {
        type: 'Custom View Opened',
        new_overview: true,
        view_type: this.props.withCustomViews,
        parameters: this.getViewParameters()
      });
    }
  }, {
    key: "trackCustomViewSaved",
    value: function trackCustomViewSaved() {
      _publish.default.trackEvent('userevent', {
        type: 'Custom View Saved',
        view_type: this.props.withCustomViews,
        parameters: this.getViewParameters()
      });
    }
  }, {
    key: "trackCustomViewShared",
    value: function trackCustomViewShared() {
      _publish.default.trackEvent('userevent', {
        type: 'Custom View Shared',
        view_type: this.props.withCustomViews,
        parameters: this.getViewParameters()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props4 = this.props,
          type = _this$props4.type,
          dataElementName = _this$props4.dataElementName,
          dataTrackType = _this$props4.dataTrackType,
          headerTitle = _this$props4.headerTitle,
          onTitleChanged = _this$props4.onTitleChanged,
          headerTitleLinks = _this$props4.headerTitleLinks,
          headerButtons = _this$props4.headerButtons,
          withSearch = _this$props4.withSearch,
          _this$props4$withHead = _this$props4.withHeader,
          withHeader = _this$props4$withHead === void 0 ? true : _this$props4$withHead,
          searchPlaceholder = _this$props4.searchPlaceholder,
          withFilters = _this$props4.withFilters,
          _this$props4$showFilt = _this$props4.showFilters,
          showFilters = _this$props4$showFilt === void 0 ? true : _this$props4$showFilt,
          _this$props4$isBeta = _this$props4.isBeta,
          isBeta = _this$props4$isBeta === void 0 ? false : _this$props4$isBeta,
          areAppliedFiltersHiddenByDefault = _this$props4.areAppliedFiltersHiddenByDefault,
          withCustomViews = _this$props4.withCustomViews,
          message = _this$props4.message,
          EmptyStateComponent = _this$props4.EmptyStateComponent,
          hasStickyMessage = _this$props4.hasStickyMessage,
          stickyMessageVariant = _this$props4.stickyMessageVariant,
          stickyMessage = _this$props4.stickyMessage,
          boundedContext = _this$props4.boundedContext,
          dataEntity = _this$props4.dataEntity,
          _this$props4$useFallb = _this$props4.useFallbackWhenDataEmpty,
          useFallbackWhenDataEmpty = _this$props4$useFallb === void 0 ? true : _this$props4$useFallb;
      var _this$state10 = this.state,
          data = _this$state10.data,
          filters = _this$state10.filters,
          loading = _this$state10.loading,
          areFiltersApplied = _this$state10.areFiltersApplied,
          showAlert = _this$state10.showAlert,
          _this$state10$alertMe = _this$state10.alertMessage,
          alertMessage = _this$state10$alertMe === void 0 ? '' : _this$state10$alertMe,
          alertType = _this$state10.alertType,
          alertVisibleFor = _this$state10.alertVisibleFor,
          customViewId = _this$state10.customViewId,
          customViewError = _this$state10.customViewError,
          customViewTitle = _this$state10.customViewTitle;
      var isCustomView = !!customViewId;
      var hasData = data.length > 0;
      var showNoResultFound = withFilters && (areFiltersApplied || Overview.isSharedView());
      var table = hasData || !useFallbackWhenDataEmpty ? // @ts-expect-error 123
      (0, _preact.h)(_Table.default, this.getTableProps()) : (0, _preact.h)(_EmptyView.default, {
        loading: loading,
        EmptyStateComponent: EmptyStateComponent !== null && EmptyStateComponent !== void 0 ? EmptyStateComponent : (0, _preact.h)("div", null),
        showNoResultFound: showNoResultFound
      });
      return (0, _preact.h)("div", {
        className: "overview",
        "data-bounded-context": boundedContext,
        "data-entity": dataEntity
      }, loading && (0, _preact.h)(_Loader.default, null), showAlert && (0, _preact.h)(_AlertComponent.default, {
        message: alertMessage,
        messageType: alertType,
        isVisibleFor: alertVisibleFor,
        sticky: true,
        onTimeoutEnd: function onTimeoutEnd() {
          return _this8.setState({
            showAlert: false
          });
        }
      }), withHeader && (0, _preact.h)(_Header.default, {
        type: type,
        title: isCustomView ? customViewTitle : headerTitle,
        isCustomView: !!onTitleChanged || isCustomView,
        onTitleChanged: this.onTitleChanged,
        customButtons: headerButtons,
        isBeta: isBeta,
        titleLinks: headerTitleLinks,
        customViewActions: withCustomViews && (data.length > 0 || areFiltersApplied || Overview.isSharedView()) ? (0, _preact.h)(_CustomViewActions.default, {
          isCustomView: isCustomView,
          customViewName: customViewTitle,
          onShareView: this.handleShareView,
          onSaveCustomView: this.handleSaveCustomView,
          onDeleteCustomView: this.handleDeleteCustomView,
          errorMessage: customViewError
        }) : this.renderStateAwareHeaderComponent()
      }), hasStickyMessage && (0, _preact.h)(_Message.Message, {
        variant: stickyMessageVariant,
        text: stickyMessage
      }), message && message, this.renderStateAwareDashboardComponent(), withFilters && showFilters && (data.length > 0 || (0, _objectKeys.default)(filters !== null && filters !== void 0 ? filters : {}).length > 0 || areFiltersApplied || Overview.isSharedView()) && (0, _preact.h)(_OverviewFilters.default, {
        filters: withFilters,
        appliedFilters: filters,
        onFilterChange: this.handleFilterChange,
        onClearFilterCriteria: this.handleClearFilterCriteria,
        withSearch: withSearch,
        searchPlaceholder: searchPlaceholder,
        areAppliedFiltersHiddenByDefault: areAppliedFiltersHiddenByDefault,
        dataTrackType: dataTrackType,
        dataElementName: dataElementName ? "".concat(dataElementName, " refresh button") : undefined
      }), table);
    }
  }], [{
    key: "getCustomViewId",
    value: function getCustomViewId() {
      return parseInt(window.location.pathname.split('/overview/')[1]);
    }
  }, {
    key: "getSharedView",
    value: function getSharedView() {
      var search = _qs.default.parse(window.location.search, {
        ignoreQueryPrefix: true
      });

      var view = search === null || search === void 0 ? void 0 : search.view;

      try {
        // @ts-expect-error
        return JSON.parse(window.atob(view));
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "isCustomView",
    value: function isCustomView() {
      return !!Overview.getCustomViewId();
    }
  }, {
    key: "isSharedView",
    value: function isSharedView() {
      return !!Overview.getSharedView();
    }
  }]);
  return Overview;
}(_preact.Component);

var _default = Overview;
exports.default = _default;